<template>
    <div class="flex relative items-center"
         v-bind="$attrs">
        <div class="flex h-10 relative">
            <button @click.stop="triggerMenu"
                    class="flex items-center px-4 rounded-lg cursor-pointe background-black focus:outline-none shadow-base">
                <span class="text-color mx-1 text-main-sm md:text-main-lg w-30 truncate">
                    {{ currentAccount.name || $t('navbar.default.username') }}
                </span>
                <IconArrowDown class="text-color transition mx-1" :class="{'is-expanded': showMenu}"/>
            </button>
            <fade-transition :duration="350">
                <div v-click-outside="onMenuClickOutside"
                     class="menu-wrapper background-black"
                     v-if="showMenu">
                    <span
                        :class="{ 'text-primary': currentAccountId === account.ID}"
                        @click="chooseAccount(account)"
                        class="text-color hover:text-primary py-3 px-4 cursor-pointer border-b"
                        v-for="(account, index) in allAccounts" :key="index"
                    >
                        {{ account.name || $t('navbar.default.username') }}
                    </span>
                    <span
                        @click="logout"
                        class="text-color !hover:text-primary py-3 px-4 cursor-pointer"
                    >
                        {{ $t('navbar.logout') }}
                    </span>
                </div>
            </fade-transition>
        </div>
    </div>
</template>
<script>

export default {
    inheritAttrs: false,
    data() {
        return {
            showMenu: false,
        }
    },
    computed: {
        currentAccount() {
            return this.$store.getters['entities/getCurrentAccount']
        },
        currentAccountId () {
            return this.$store.state.entities.selectedAccountID
        },
        allAccounts() {
            return this.$store.getters['entities/accountsList']
        },
    },
    methods: {
        onMenuClickOutside() {
            this.showDashboardsMenu = false
            this.showMenu = false
        },
        chooseAccount(account) {
            this.$store.commit('entities/SET_SELECTED_ACCOUNT_ID', account.ID)
            this.showMenu = false
            this.getUserDashboards()
            this.$emit('currentAccountIdUpdated', account.ID)
        },
        resetOldActiveDashboard() {
          localStorage.removeItem('active-dashboard')
        },
        async getUserDashboards() {
            this.resetOldActiveDashboard()
            await this.$store.dispatch('dashboards/getDashboards')
            await this.$store.dispatch('dashboards/selectDashboard')
        },
        logout() {
            localStorage.clear()
            this.$store.dispatch('users/logout')
        },
        triggerMenu() {
            this.showMenu = !this.showMenu
        }
    },
}
</script>
<style lang="scss" scoped>
.menu-wrapper {
    @apply z-50 rounded mt-12 absolute px-3 flex flex-col origin-top-right right-0 max-h-64 overflow-auto;
    box-shadow: 0 0 5px var(--gray-350);
}

.transition {
    transition: all 0.2s ease-in;
}

.is-expanded {
    transform: rotate(-180deg);
}

.circle-indicator {
    @apply w-2 h-2 rounded-full bg-green-main;
    content: '';
}
.background-black {
    background: var(--secondaryBgColor-color);
}
</style>
